import React from 'react';
import { connect } from 'react-redux';
import { Form } from 'semantic-ui-react';
import { validationClasses, findError } from '@/utils/errors';
import { states } from '@/constants/lifecycle';
import fields from '@/constants/fields';
import FormValidationError from '@/components/errors/FormValidationError';
import { datasetSettingsFields } from '@/datasets/settings/state/state';
import fetch from '../datasets/hooks/fetch';
import { fetchRequestDatasetSettings } from '../datasets/actions';
import { updateRequestTransferType } from '../actions';
import RequestDictionariesDropdown from '../datasets/containers/RequestDictionariesDropdown';
import RequestTransferTypeDropdown from '../components/RequestTransferTypeDropdown';
import { requestSources } from '../constants';
import RequestCohortsDropdown from '../cohorts/containers/RequestCohortsDropdown';
import { withSourceSelection } from '../helper';
import {
  supportedRequestTransferTypes, resolveRequestWorkflow, requestDatasetCode, newRequest,
} from '../state/state';
import SelectWorkspaces from '../workspaces/components/SelectWorkspaces';
import SelectDestinationNamespace from '../namespaces/containers/SelectDestinationNamespace';

const RequestDestinationForm = ({
  category,
  code,
  compact,
  datasetCode,
  fetchData,
  readStatus,
  saveErrors,
  saveStatus,
  showSourceSelection,
  sourceType,
  supportsTransferType,
  transferType,
  transferTypes,
  updateTransferType,
}) => {
  fetch.useFetchRequestDatasetSettings(fetchData, category, code, datasetCode, readStatus, sourceType);
  const transferTypeError = findError(saveErrors, 'transfer', [fields.TYPE]);
  return (
    <Form autoComplete="off">
      {showSourceSelection && (
        <>
          {sourceType === requestSources.DATASET && (<RequestDictionariesDropdown category={category} code={code} />)}
          {sourceType === requestSources.COHORT && (<RequestCohortsDropdown category={category} code={code} />)}
          {supportsTransferType && (
          <FormValidationError
            htmlFor="transfer_type_dropdown"
            labelId="access.transfer.type"
            error={transferTypeError}
          >
            <RequestTransferTypeDropdown
              transferType={transferType}
              transferTypes={transferTypes}
              disabled={saveStatus === states.PENDING}
              onChange={(value) => updateTransferType(category, code, value)}
              className={validationClasses(transferTypeError)}
            />
          </FormValidationError>
          )}
        </>
      )}
      <SelectDestinationNamespace category={category} code={code} />
      <SelectWorkspaces category={category} code={code} compact={compact} />
    </Form>
  );
};

const mapStateToProps = ({
  requests: { allowPmnTransfer, requests },
  workflows: { workflows },
}, ownProps) => {
  const { request, source } = resolveRequestWorkflow(requests, workflows, ownProps, newRequest(ownProps));
  const safeSource = source || { settings: datasetSettingsFields(), settingsReadStatus: states.NONE };
  const transferTypes = supportedRequestTransferTypes(safeSource, allowPmnTransfer);

  return (
    {
      datasetCode: requestDatasetCode(request, safeSource),
      readStatus: safeSource.settingsReadStatus,
      saveErrors: request.saveErrors,
      saveStatus: request.saveStatus,
      showSourceSelection: withSourceSelection(safeSource.settings),
      sourceType: request.request_source,
      supportsTransferType: Object.keys(transferTypes).length > 1,
      transferType: request.transfer.transfer_type,
      transferTypes,
    }
  );
};

const mapDispatchToProps = {
  fetchData: fetchRequestDatasetSettings,
  updateTransferType: updateRequestTransferType,
};

export default connect(mapStateToProps, mapDispatchToProps)(RequestDestinationForm);
